export const HEALTH_RECORD_REQUEST = 'HEALTH_RECORD_REQUEST';
export const HEALTH_RECORD_REQUEST_SUCCESS = 'HEALTH_RECORD_REQUEST_SUCCESS';
export const HEALTH_RECORD_REQUEST_ERROR = 'HEALTH_RECORD_REQUEST_ERROR';

export const CLICKED_HEALTH_ID = 'CLICKED_HEALTH_ID';

export const RECORD_IMAGE_OPEN = 'RECORD_IMAGE_OPEN';
export const RECORD_IMAGE_OPEN_SUCCESS = 'RECORD_IMAGE_OPEN_SUCCESS';
export const RECORD_IMAGE_OPEN_FAILED = 'RECORD_IMAGE_OPEN_FAILED';

export const HEALTH_REC_TYPES = 'HEALTH_REC_TYPES';
export const HEALTH_REC_TYPES_SUCCESS = 'HEALTH_REC_TYPES_SUCCESS';
export const HEALTH_REC_TYPES_FAILED = 'HEALTH_REC_TYPES_FAILED';

export const HEALTH_REC_UPLOAD = 'HEALTH_REC_UPLOAD';
export const HEALTH_REC_UPLOAD_SUCCESS = 'HEALTH_REC_UPLOAD_SUCCESS';
export const HEALTH_REC_UPLOAD_FAILED = 'HEALTH_REC_UPLOAD_FAILED';